// @ts-nocheck
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mvpApi } from '../services/api';
import PostLandingShell from '../components/PostLandingShell';
import { getPathWithRef } from '../utils/attribution';
import LanguageSwitch from '../components/LanguageSwitch';
import './Success.css';

const APPLICANT_ENTRY_INTENT_KEY = 'mvp_applicant_entry_intent';

export default function Success() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate(getPathWithRef('/es/regularizacion'), { replace: true });
      return;
    }
    sessionStorage.setItem(APPLICANT_ENTRY_INTENT_KEY, 'signup');
    mvpApi
      .getMe()
      .then((res) => {
        const u = res.data?.user || res.data;
        const role = u?.role?.value ?? u?.role;
        if (role === 'admin') navigate('/advisor', { replace: true });
      })
      .catch(() => navigate(getPathWithRef('/es/regularizacion')));
  }, [navigate]);

  return (
    <PostLandingShell
      pageClassName="gm-pl-page--success"
      headerAside={<LanguageSwitch />}
      hero={<></>}
      badge={t('successPage.completedBadge')}
      title={t('successPage.title')}
      subtitle={<p className="gm-pl-subtitle">{t('successPage.body')}</p>}
      listItems={[]}
      footnote=""
      primaryLabel={t('successPage.getStarted')}
      onPrimary={() => {
        window.location.assign('/intake');
      }}
      onBrandClick={() => {
        window.location.href = 'https://globalmobility.law/';
      }}
    />
  );
}
